import { createContext, useContext } from 'react';

import type { PatientInfoFragment } from '../graphql/generated/graphql';

export type PatientCtx = {
    patient: PatientInfoFragment;
};

export const PatientContext = createContext<PatientCtx | null>(null);

export const usePatientContext = (): PatientCtx => {
    const ctx = useContext(PatientContext);

    if (ctx === null) {
        throw new Error(
            'usePatientContext must be used within a PatientContext'
        );
    }

    return ctx;
};

export const useOptionalPatientContext = (): PatientCtx | null =>
    useContext(PatientContext);
